import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { LandingPageTemplate } from '../components/templates/LandingPageTemplate';
import useApi from '../hooks/use-api';

function LandingPage() {
	const navigate = useNavigate();
	const [content, setContent] = useState({ de: '', en: '' });
	const { http } = useApi();

	useEffect(() => {
		const loadContent = async () => {
			const response = await http('GET', `LandingPage`);
			const result = response?.data;
			setContent(result);
		};
		loadContent();
	}, [http]);

	return <LandingPageTemplate content={content} onCreate={() => navigate('/report')} onHome={() => navigate('/')} />;
}

export default LandingPage;
